import { useEffect } from 'react'
import { useDream } from '@/hooks/useDream'
import { useLanguage } from '@/hooks/useLanguage'
import { useLoading } from '@/store/contexts/LoadingContext'
import { t } from '@/utils/i18n'
import EmptyState from '@/components/common/EmptyState/EmptyState'

import { IconMessage } from '@/components/icons/Icons'
import './Coaching.css'

/** 코칭 REST를 사용하지 않음 — 안내 전용 화면 */
function Coaching() {
  const { language } = useLanguage()
  const { stopLoading } = useLoading()
  const { dreams } = useDream()

  useEffect(() => {
    stopLoading()
  }, [stopLoading])

  return (
    <div className="coaching">
      <div className="coaching__content">

        {dreams.length === 0 ? (
          <EmptyState
            icon={<IconMessage size={32} />}
            title={t('coaching.noDreams', language)}
            description={t('coaching.noDreamsDesc', language) || ''}
          />
        ) : (
          <EmptyState
            icon={<IconMessage size={32} />}
            title={language === 'ko' ? '코칭 메시지 없음' : 'No coaching messages'}
            description={
              language === 'ko'
                ? '로컬 전용 모드에서는 AI 코칭 기록이 표시되지 않습니다.'
                : 'AI coaching history is not available in local-only mode.'
            }
          />
        )}
      </div>
    </div>
  )
}

export default Coaching
